<template>
  <section>
    <!--     <header v-if="title">{{ title }}</header> -->
    <section class="dialog-content">
      <p>
        Let op, nog niet alle bestanden zijn toegevoegd aan uw winkelwagen. Wilt
        u toch doorgaan met het afronden van uw bestelling?
      </p>

      <div class="button-holder">
        <button
          class="pill-button secondary"
          @click="$emit('close')"
          v-if="currentRoute === 'productOrder'"
        >
          Annuleren
        </button>
        <button class="pill-button secondary" @click="goToOrder" v-else>
          Bestanden bekijken
        </button>
        <button class="pill-button" @click="toCart">
          Verder naar bestellen
        </button>
      </div>
    </section>
  </section>
</template>
<script>
export default {
  props: ['currentRoute'],
  methods: {
    goToOrder() {
      this.$router.push({ name: 'productOrder' })
      this.$emit('close')
    },
    toCart() {
      this.$router.push({ name: 'checkOut' })
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.secondary {
  margin-right: 5px;
}
</style>
